/** @format */

import React, { useState } from 'react'
import styled from 'styled-components'
import { _$, Button, dayjs, Drawer, Pagination, Table, TableColumn } from '@king-design/react'
import { getStatus, TriggerRecordItemProp } from '../container'
import { useAsync } from 'react-use'
import { UserInfo } from 'src/components'
import { useHistory } from 'react-router-dom'
import { getTriggerList } from 'src/api/ApiEventOpsTrigger'
import { PageProps, initPage } from 'src/utils/interface'

interface VersionDrawerProps {
  className?: string
  visible: boolean
  record: TriggerRecordItemProp
  onClose: () => void
  openEdit: (record: TriggerRecordItemProp, editable: boolean) => void
}

const VersionDrawer: React.FC<VersionDrawerProps> = ({
  className,
  record,
  visible,
  openEdit,
  onClose
}) => {
  const history = useHistory()
  const [page, setPage] = useState<PageProps>(initPage)
  const { value: versionList } = useAsync(async () => {
    if (visible && record?.Sign) {
      const result = await getTriggerList({
        Sign: record?.Sign,
        Limit: page.PageSize,
        Offset: (page.Page - 1) * page.PageSize
      })
      return result
    } else {
      setPage(initPage)
      return {
        Info: [],
        Total: 0
      }
    }
  }, [visible, page])

  return (
    <div id="version-page" className={className}>
      <Drawer
        value={visible}
        width={1000}
        title={_$('版本')}
        container={() => document.getElementById('version-page')}
        onChangeValue={show => {
          if (!show) {
            onClose()
          }
        }}
        slotFooter={
          <Button
            onClick={() => {
              onClose()
            }}
          >
            {_$('关闭')}
          </Button>
        }
      >
        <>
          <Table
            data={versionList?.Info || []}
            animation={false}
            rowKey={record => record?.ID || record?.Sign}
            checkType="none"
          >
            <TableColumn key="ID" title="ID" width="50" />
            <TableColumn key="Name" title={_$('规则名称')} />
            <TableColumn
              key="Creator"
              title={_$('操作人')}
              slotTemplate={([{ Creator }]) => {
                return <UserInfo name={Creator} />
              }}
            />
            <TableColumn
              key="CreatedAt"
              title={_$('创建时间')}
              width="100"
              slotTemplate={([{ CreatedAt }]) => {
                return CreatedAt ? dayjs(CreatedAt).format('YYYY-MM-DD HH:mm:ss') : '-'
              }}
            />
            <TableColumn
              key="PublishedAt"
              title={_$('发布时间')}
              width="100"
              slotTemplate={([{ PublishedAt }]) => {
                return PublishedAt ? dayjs(PublishedAt).format('YYYY-MM-DD HH:mm:ss') : '-'
              }}
            />
            <TableColumn
              key="Version"
              title={_$('版本')}
              width="80"
              slotTemplate={([{ Version }]) => {
                return Version ? Version : '-'
              }}
            />
            <TableColumn
              key="VersionRemark"
              title={_$('版本说明')}
              slotTemplate={([{ VersionRemark }]) => {
                return VersionRemark ? VersionRemark : '-'
              }}
            />
            <TableColumn
              key="TriggerTimes"
              title={_$('触发记录/次')}
              width="100"
              slotTemplate={([{ Sign, ID, TriggerTimes }]) => {
                return TriggerTimes > 0 ? (
                  <a onClick={() => history.push(`/monitor/eventops/trigger/record/${Sign}/${ID}`)}>
                    {TriggerTimes}
                  </a>
                ) : (
                  <span>0</span>
                )
              }}
            />
            <TableColumn
              key="Status"
              title={_$('状态')}
              fixed="right"
              width="100"
              slotTemplate={([{ Status }]) => {
                return getStatus(Status)
              }}
            />
            <TableColumn
              key="operations"
              title={_$('操作')}
              fixed="right"
              width="60"
              slotTemplate={([record]) => {
                return record.actions?.includes('owner') && record.status !== -2 ? (
                  <>
                    <a
                      onClick={() => {
                        openEdit(record, true)
                      }}
                    >
                      {_$('编辑')}
                    </a>
                  </>
                ) : (
                  <a
                    onClick={() => {
                      openEdit(record, false)
                    }}
                  >
                    {_$('查看')}
                  </a>
                )
              }}
            />
          </Table>
          <Pagination
            value={page.Page}
            limit={page.PageSize}
            size="small"
            total={versionList?.Total || 0}
            onChangeValue={value => {
              setPage({
                ...page,
                Page: value
              })
            }}
            onChangeLimit={limit => {
              setPage({
                ...page,
                PageSize: limit
              })
            }}
          />
        </>
      </Drawer>
    </div>
  )
}

export default styled(VersionDrawer)`
  .k-dialog-wrapper {
    z-index: 9998;
  }
`
